import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { useState, useCallback } from 'react';

const testimonials = [
  {
    name: '李先生',
    age: 38,
    location: '北京',
    text: '结婚十年，去年差点离婚。通过爱妻艺找回的系统学习，我真正认识到了自己的问题所在。按照实操步骤一步步改变，三个月后妻子主动搬回了主卧。现在我们的关系比新婚时还好。真心感谢！',
    rating: 5,
  },
  {
    name: '张先生',
    age: 42,
    location: '上海',
    text: '分居了四个月，我以为这段婚姻已经没救了。看了爱妻艺找回来的文章后，我停止了之前那些错误的挽回方式，给了她空间，也改变了自己。两个月后她主动约我吃饭，现在我们正在慢慢修复。',
    rating: 5,
  },
  {
    name: '王先生',
    age: 35,
    location: '广州',
    text: '妻子提出离婚的那一刻，我的世界崩塌了。在最绝望的时候发现了爱妻艺找回，里面的内容让我醍醐灌顶——原来我之前一直在用错误的方式对待婚姻。跟着指南改变了自己，现在我的婚姻回来了。',
    rating: 5,
  },
  {
    name: '刘先生',
    age: 45,
    location: '深圳',
    text: '以前总觉得挣钱养家就够了，忽略了妻子的情感需求。通过学习心理分析的内容，我终于理解了妻子的感受。改变的不仅是婚姻，更是我自己。感谢爱妻艺找回给我的指引。',
    rating: 5,
  },
  {
    name: '陈先生',
    age: 33,
    location: '成都',
    text: '冷战半年后妻子提出分居，我心急如焚到处找办法。爱妻艺找回的文章给我指明了方向——先改变自己，再修复关系。现在我们已经重新走到了一起，这段经历反而让我们的感情更坚固了。',
    rating: 5,
  },
  {
    name: '赵先生',
    age: 40,
    location: '杭州',
    text: '看了很多情感类的文章，但爱妻艺找回的内容是最系统、最实用的。从心理分析到实操步骤，每一篇都让我有新的收获。按照沟通技巧中的方法，我和妻子的对话终于不再以争吵收场了。',
    rating: 5,
  },
];

const values = [
  {
    icon: 'ri-heart-line',
    title: '真诚',
    description: '我们坚持用最真诚的态度对待每一位来访者，每一篇文章都源于真实的经验和专业的知识。',
  },
  {
    icon: 'ri-lightbulb-line',
    title: '专业',
    description: '融合心理学、沟通学和婚姻咨询的专业理论，提供经得起验证的系统化解决方案。',
  },
  {
    icon: 'ri-shield-user-line',
    title: '隐私',
    description: '严格保护每一位用户的隐私，你的故事我们用心倾听，但绝不对外泄露。',
  },
  {
    icon: 'ri-team-line',
    title: '陪伴',
    description: '婚姻修复是一段旅程，我们不只是提供知识，更是陪伴你走过这段艰难时光的伙伴。',
  },
];

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleFormSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      setFormMessage('留言已提交，我们会尽快与您联系！');
      form.reset();
      return;
    }

    const urlEncoded = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'phone_alt') {
        urlEncoded.append(key, String(value));
      }
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d9q15bsnlsngrm4llpr0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlEncoded.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || '';
      const isSpam = serverMsg.includes('spam') || serverMsg.includes('form data is spam');

      if (response.ok && parsed?.code === 'OK' && !isSpam) {
        setFormStatus('success');
        setFormMessage('留言已提交成功，我们会尽快与您联系！');
        form.reset();
      } else {
        setFormStatus('error');
        setFormMessage(serverMsg || '提交失败，请稍后再试');
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请稍后重试');
    }
  }, []);

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于爱妻艺找回',
    description: '爱妻艺找回是专为已婚男性打造的情感挽回平台。了解我们的品牌故事、核心价值观和联系方式。',
    url: 'https://aiqiyi-zhaihui.com/about',
    mainEntity: {
      '@type': 'Organization',
      name: '爱妻艺找回',
      url: 'https://aiqiyi-zhaihui.com/',
      description: '专为已婚男性打造的情感挽回解决方案',
      foundingDate: '2014',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        telephone: '+86-400-888-9999',
        availableLanguage: ['Chinese'],
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: '建国路88号',
        addressLocality: '北京',
        addressRegion: '朝阳区',
        addressCountry: 'CN',
      },
    },
  };

  return (
    <>
      <SEO
        title="关于我们 - 爱妻艺找回 | 品牌故事、口碑评价、联系方式"
        description="了解爱妻艺找回的品牌故事和核心价值观。我们致力于为已婚男性提供专业的情感挽回解决方案，已服务超过10,000个家庭，挽回成功率达87%。"
        keywords="爱妻艺找回,关于我们,品牌故事,婚姻修复,情感挽回,联系方式"
        canonicalUrl="https://aiqiyi-zhaihui.com/about"
        schema={aboutSchema}
      />
      <Navbar />

      <main className="pt-20">
        <section className="w-full px-4 md:px-6 py-10 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-14">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                关于爱妻艺找回
              </h1>
              <p className="text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                用专业和真诚，帮助每一位丈夫找回幸福婚姻
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-5">
                  品牌故事
                </h2>
                <div className="text-foreground-700 leading-relaxed space-y-4 text-sm md:text-base">
                  <p>
                    爱妻艺找回创立于2014年，源于创始团队对婚姻危机的深切关注。我们见证过太多原本相爱的夫妻因为沟通不畅、信任缺失、生活琐事等可解决的问题而走向分离，这让我们深感痛心。
                  </p>
                  <p>
                    我们的创始团队由婚姻家庭咨询师、心理学专家和情感教育工作者组成。经过多年的一线实践和研究，我们总结出了一套系统化的婚姻挽回方法论——从心理认知到沟通技巧，从信任重建到行动方案，形成了完整的知识体系。
                  </p>
                  <p>
                    十二年来，我们已累计服务超过10,000个家庭，帮助成千上万的丈夫成功挽回了妻子的心，修复了濒临破碎的婚姻。我们深知每一个家庭背后都有独特的故事，但我们相信，只要用对方法，大多数婚姻危机都可以化解。
                  </p>
                </div>
              </div>
              <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20and%20professional%20team%20of%20counselors%20sitting%20around%20a%20wooden%20table%20in%20a%20bright%20modern%20office%2C%20discussing%20and%20collaborating%2C%20natural%20daylight%2C%20warm%20amber%20and%20cream%20tones%2C%20professional%20yet%20approachable%20atmosphere%2C%20editorial%20photography%20with%20clean%20composition&width=800&height=600&seq=about-story-01&orientation=landscape"
                  alt="爱妻艺找回团队"
                  title="爱妻艺找回专业团队"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
                核心价值观
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {values.map((v, i) => (
                  <div
                    key={i}
                    className="bg-background-100 border border-background-200/70 rounded-lg p-6 text-center"
                  >
                    <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                      <i className={`${v.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                      {v.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {v.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                用户口碑
              </h2>
              <p className="text-foreground-600">
                来自真实用户的反馈，他们和你一样经历过婚姻危机
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t, i) => (
                <div
                  key={i}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-5"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, j) => (
                      <i
                        key={j}
                        className="ri-star-fill text-accent-500 text-sm"
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{t.text}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center font-heading font-bold text-sm">
                      {t.name.charAt(0)}
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">
                        {t.name}
                      </div>
                      <div className="text-xs text-foreground-500">
                        {t.age}岁 · {t.location}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                联系我们
              </h2>
              <p className="text-foreground-600">
                有问题？想咨询？我们随时在这里等你
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <div className="flex flex-col gap-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-phone-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">
                      电话咨询
                    </h3>
                    <p className="text-sm text-foreground-600 mb-1">
                      400-888-9999
                    </p>
                    <p className="text-xs text-foreground-500">
                      周一至周五 9:00 - 18:00
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">
                      邮件联系
                    </h3>
                    <p className="text-sm text-foreground-600">
                      contact@aiqiyi-zhaihui.com
                    </p>
                    <p className="text-xs text-foreground-500">
                      我们会在24小时内回复
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-map-pin-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">
                      公司地址
                    </h3>
                    <p className="text-sm text-foreground-600">
                      北京市朝阳区建国路88号
                    </p>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="relative w-full aspect-[16/9] rounded-lg overflow-hidden">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3061.389471299196!2d116.4586!3d39.9087!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35f0515b5b1b1b1b%3A0x1b1b1b1b1b1b1b1b!2sBeijing%20CBD!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen={false}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="爱妻艺找回公司位置"
                      className="absolute inset-0"
                    ></iframe>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 border border-background-200/70 rounded-lg p-6">
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-5">
                  发送消息
                </h3>
                <form className="flex flex-col gap-4" data-readdy-form="contact" onSubmit={handleFormSubmit}>
                  <div>
                    <label htmlFor="about-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      姓名
                    </label>
                    <input
                      type="text"
                      id="about-name"
                      name="name"
                      className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入您的姓名"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="about-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      邮箱
                    </label>
                    <input
                      type="email"
                      id="about-email"
                      name="email"
                      className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入您的邮箱"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="about-phone" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      电话
                    </label>
                    <input
                      type="tel"
                      id="about-phone"
                      name="phone"
                      className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                      placeholder="请输入您的电话"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      留言
                    </label>
                    <textarea
                      id="about-message"
                      name="message"
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                      placeholder="请描述您的情况（500字以内）"
                      required
                    ></textarea>
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    readOnly
                    aria-hidden="true"
                    className="absolute opacity-0 pointer-events-none"
                    style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}
                  />
                  {formStatus !== 'idle' && (
                    <div className={`text-sm px-4 py-3 rounded-lg ${formStatus === 'success' ? 'bg-accent-100 text-accent-700' : 'bg-red-50 text-red-700'}`}>
                      {formMessage}
                    </div>
                  )}
                  <button
                    type="submit"
                    className="w-full inline-flex items-center justify-center px-6 py-3 text-sm font-medium whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    提交留言
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}